/**
 * Created by Ning Jiang on 2021-06-28.
 */

import {ContinueScreen} from "../../core/screen/ContinueScreen";
import {Layers, TombstoneRipLayers} from "../view/TombstoneRipLayers";
import {TombstoneRip} from "../TombstoneRip";
import {gsap, TimelineLite} from "gsap";
import {SlotGame} from "@nolimitcity/slot-game/bin/SlotGame";
import {BitmapTextStyleOptions} from "@nolimitcity/slot-game/bin/text/BitmapTextStyleOptions";
import {TombstoneRipGameAssets} from "../TombstoneRipGameAssets";
import {TombstoneRipGameMode} from "../gameflow/TombstoneRipGameMode";
import {SpineTween} from "@nolimitcity/slot-game/bin/animation/SpineTween";
import {TombstoneRipSound} from "../sound/TombstoneRipSound";

export class FreespinIntro extends ContinueScreen {

    private readonly _numberStyle_FREESPIN:BitmapTextStyleOptions = {
        fontName : TombstoneRipGameAssets.BITMAP_FONT_FS_INTRO_NUMBER_FS,
        fontSize : 35,
        tint : 0xffffff
    };
    private readonly _numberStyle_FREESPIN_SUPER:BitmapTextStyleOptions = {
        fontName : TombstoneRipGameAssets.BITMAP_FONT_FS_INTRO_NUMBER_FS_SUPER,
        fontSize : 35,
        tint : 0xffffff
    };
    private _dimmer:PIXI.Graphics;
    private _fsBg:PIXI.spine.Spine | null;
    private _fsIntro:PIXI.spine.Spine | null;
    private _dust:PIXI.spine.Spine | null;
    private _girlHead:PIXI.spine.Spine | null;
    private _bgContainer:PIXI.Container;
    private _number_FREESPIN:PIXI.BitmapText;
    private _number_FREESPIN_SUPER:PIXI.BitmapText;
    private _fsName:PIXI.Sprite;

    constructor() {
        super(TombstoneRipLayers.getLayer(Layers.SCREENS)!);

        this._dimmer = new PIXI.Graphics();
        this._dimmer.alpha = 0;
        this._dimmer.position.set(360, 360);
        this._dimmer.beginFill(0x000000, 1);
        this._dimmer.drawRect(-840, -840, 1680, 1680);
        this._dimmer.endFill();
        this._container.addChild(this._dimmer);

        this._bgContainer = new PIXI.Container();
        this._bgContainer.position.set(360, 360);
        this._container.addChild(this._bgContainer);

        this._number_FREESPIN = new PIXI.BitmapText("", this._numberStyle_FREESPIN);
        (<PIXI.Point>this._number_FREESPIN.anchor).set(0, 0.5);
        this._number_FREESPIN.position.set(360, 240);
        this._container.addChild(this._number_FREESPIN);

        this._number_FREESPIN_SUPER = new PIXI.BitmapText("", this._numberStyle_FREESPIN_SUPER);
        this._number_FREESPIN_SUPER.letterSpacing = -10;
        (<PIXI.Point>this._number_FREESPIN_SUPER.anchor).set(0, 0.5);
        this._number_FREESPIN_SUPER.position.set(360, 190);
        this._container.addChild(this._number_FREESPIN_SUPER);

        this._fsName = new PIXI.Sprite();
        this._fsName.anchor.set(1, 0.5);
        this._fsName.position.set(360, 220);
        this._container.addChild(this._fsName);

        this.reset();
    }

    public show(onContinueCallBack:() => void):void {
        SlotGame.keypadPlugin.hide();

        const nextMode = TombstoneRip.model.currentParsedData.nextMode;
        const fsLeft = TombstoneRip.model.isRestore ? TombstoneRip.model.currentParsedData.freespinsLeft : TombstoneRip.model.parsedGameData.freespinsLeft;
        const number = <PIXI.BitmapText>(<any>this)[`_number_${nextMode}`];
        number.text = `${fsLeft}`;
        // number.text = `0123456789`;
        this._fsName.texture = TombstoneRip.assetLoader.getTextures(`fsintro/${nextMode}${fsLeft === 1 ? "" : "S"}_INTRO`)[0];
        const textOffset = (number.textWidth + this._fsName.width + 20) * 0.5;
        number.x = 360 - textOffset;
        this._fsName.x = 360 + textOffset;
        this._fsName.y = TombstoneRip.model.data.nextMode === TombstoneRipGameMode.FREESPIN_SUPER ? 220 : 270;

        let delay = 0.5;
        const tl = new TimelineLite();
        tl.add(() => {
            this.visible = true;
            TombstoneRip.xBetController.featureVisible = false;
            this.playTransitionSound();
            TombstoneRip.scatters.stopAllScatters();
        }, delay);
        tl.add(this.getPostTimeline(), delay);
        delay = tl.totalDuration();
        tl.add(gsap.to(number, {duration : 0.3, alpha : 1}), delay);
        tl.add(gsap.to(this._fsName, {duration : 0.3, alpha : 1}), delay);
        tl.add(() => {
            TombstoneRip.background.updateEnvironment(TombstoneRip.model.currentParsedData.nextMode);
            TombstoneRip.multiplier.initFS();
            super.show(onContinueCallBack);
        });
    }

    private playTransitionSound():void {
        TombstoneRipSound.soundPlayer.playTrack({
            name : TombstoneRip.model.data.nextMode === TombstoneRipGameMode.FREESPIN_SUPER ?
                TombstoneRipSound.SUPER_FS_INTRO_TRANSITION : TombstoneRipSound.FS_INTRO_TRANSITION
        });
        TombstoneRipSound.fadeMusic(0, 300);
    }

    private playFSStartSound():void {
        TombstoneRipSound.soundPlayer.playTrack({
            name : TombstoneRip.model.data.nextMode === TombstoneRipGameMode.FREESPIN_SUPER ?
                TombstoneRipSound.SUPER_FS_INTRO_START : TombstoneRipSound.FS_INTRO_START
        });
        if(TombstoneRip.model.data.nextMode === TombstoneRipGameMode.FREESPIN_SUPER) {
            TombstoneRipSound.soundPlayer.playTrack({
                name : TombstoneRipSound.SUPER_FS_INTRO,
                volume : 1,
                repeat : 100
            });
            TombstoneRipSound.fadeMusic(0, 1);
        } else {
            TombstoneRipSound.switchMusic({name : TombstoneRipSound.FS_INTRO_MUSIC, volume : 1});
        }
    }

    private startFSMusic():void {
        TombstoneRipSound.soundPlayer.playTrack({
            name : TombstoneRip.model.data.nextMode === TombstoneRipGameMode.FREESPIN_SUPER ?
                TombstoneRipSound.SUPER_FS_BUTTON : TombstoneRipSound.FS_BUTTON
        });
        TombstoneRipSound.switchMusic(
            {
                name : TombstoneRip.model.data.nextMode === TombstoneRipGameMode.FREESPIN_SUPER ?
                    TombstoneRipSound.SUPER_FS_MUSIC : TombstoneRipSound.FS_MUSIC,
                volume : 1
            },
            undefined,
            {name : "", to : 0, duration : 300}
        );
        if(TombstoneRip.model.data.nextMode === TombstoneRipGameMode.FREESPIN_SUPER) {
            TombstoneRipSound.fadeAndStopSound({
                name : TombstoneRipSound.SUPER_FS_INTRO,
                to : 0,
                duration : 300
            });
        }
    }

    private getPostTimeline():TimelineLite {
        const nextMode = TombstoneRip.model.data.nextMode;
        const tl = new TimelineLite();
        tl.add(() => {
            this._dimmer.alpha = 0.6;
        });
        if(nextMode === TombstoneRipGameMode.FREESPIN_SUPER) {
            this._fsBg = new PIXI.spine.Spine(TombstoneRip.assetLoader.getSpineAsset("sfsIntroBg"));
            this._fsBg.autoUpdate = true;
            this._fsBg.visible = false;
            this._bgContainer.addChild(this._fsBg);
            this._fsIntro = new PIXI.spine.Spine(TombstoneRip.assetLoader.getSpineAsset("sfsIntro"));
            this._fsIntro.autoUpdate = true;
            this._fsIntro.visible = false;
            this._bgContainer.addChild(this._fsIntro);
            this._girlHead = new PIXI.spine.Spine(TombstoneRip.assetLoader.getSpineAsset("sfsGirlHead"));
            this._girlHead.autoUpdate = true;
            this._girlHead.visible = false;
            this._bgContainer.addChild(this._girlHead);
            this._dust = new PIXI.spine.Spine(TombstoneRip.assetLoader.getSpineAsset("sfsIntroDust"));
            this._dust.autoUpdate = true;
            this._bgContainer.addChild(this._dust);
            tl.add([
                new SpineTween(this._fsBg, 0, "bg"),
                new SpineTween(this._fsIntro, 0, !!SlotGame.apiPlugin.gameClientConfiguration.useCensoredGfxUS ? "intro_US_animation" : "idle"),
                new SpineTween(this._girlHead, 0, "grilhead"),
                () => {new SpineTween(this._dust!, 0, "dust")}
            ]);
            tl.add(() => {
                this._fsBg!.visible = true;
                this._fsIntro!.visible = true;
                this._girlHead!.visible = true;
            }, 0.1);
            tl.add(() => this.playFSStartSound(), 4.83);
        } else {
            this._fsBg = new PIXI.spine.Spine(TombstoneRip.assetLoader.getSpineAsset("fsIntroBg"));
            this._fsBg.autoUpdate = true;
            this._bgContainer.addChild(this._fsBg);
            this._dust = new PIXI.spine.Spine(TombstoneRip.assetLoader.getSpineAsset("fsIntroDust"));
            this._dust.autoUpdate = true;
            this._bgContainer.addChild(this._dust);
            this._fsIntro = new PIXI.spine.Spine(TombstoneRip.assetLoader.getSpineAsset("fsIntroPoster"));
            this._fsIntro.autoUpdate = true;
            this._fsIntro.position.set(360, 360);
            this._container.addChild(this._fsIntro);
            tl.add([
                new SpineTween(this._fsBg, 0, "background"),
                new SpineTween(this._fsIntro, 0, "postIn"),
                () => {new SpineTween(this._dust!, 0, "dust")}
            ]);
            tl.add(() => this.playFSStartSound(), 2.03);
        }
        return tl;
    }

    protected close():TimelineLite {
        const tl = super.close();
        tl.add(() => this.startFSMusic(), 0)
        tl.add(() => this.reset());
        return tl;
    }

    private reset():void {
        this._dimmer.alpha = 0;
        this._number_FREESPIN.alpha = 0;
        this._number_FREESPIN_SUPER.alpha = 0;
        this._fsName.alpha = 0;
        if(this._fsBg) {
            this._fsBg.state.clearTrack(0);
            this._fsBg.skeleton.setToSetupPose();
            this._fsBg.state.setEmptyAnimation(0, 0);
            if(this._fsBg.parent) {
                this._fsBg.parent.removeChild(this._fsBg);
            }
            this._fsBg.destroy();
            this._fsBg = null;
        }
        if(this._fsIntro) {
            this._fsIntro.state.clearTrack(0);
            this._fsIntro.skeleton.setToSetupPose();
            this._fsIntro.state.setEmptyAnimation(0, 0);
            if(this._fsIntro.parent) {
                this._fsIntro.parent.removeChild(this._fsIntro);
            }
            this._fsIntro.destroy();
            this._fsIntro = null;
        }
        if(this._dust) {
            this._dust.state.clearTrack(0);
            this._dust.skeleton.setToSetupPose();
            this._dust.state.setEmptyAnimation(0, 0);
            if(this._dust.parent) {
                this._dust.parent.removeChild(this._dust);
            }
            this._dust.destroy();
            this._dust = null;
        }
        if(this._girlHead) {
            this._girlHead.state.clearTrack(0);
            this._girlHead.skeleton.setToSetupPose();
            this._girlHead.state.setEmptyAnimation(0, 0);
            if(this._girlHead.parent) {
                this._girlHead.parent.removeChild(this._girlHead);
            }
            this._girlHead.destroy();
            this._girlHead = null;
        }
    }
}